export default __webpack_public_path__ + "static/media/panda.83b60b22.svg";